import { z } from 'zod';

const overflowFeesSchema = z.object({
    dateAdded: z.number(),
    amount: z.number(),
    dateLastUsed: z.number().nullable(),
    metadata: z.record(z.unknown()),
});

export { overflowFeesSchema };
//# sourceMappingURL=OverflowFees.js.map
